import { useI18n } from '@change-corgi/core/react/i18n';

import { usePageCopy } from 'src/app/pages/psf/share/shared/hooks';
import { useQueryParamValue } from 'src/app/shared/hooks/location';

type Result = ModelHookResult<{
	pageTitle: string;
	hideStepperProgress: boolean;
}>;

export function usePageHeading(): Result {
	const { translate } = useI18n();
	const sourceLocation = useQueryParamValue('source_location');
	const {
		data: { progressBarLabelText },
	} = usePageCopy();

	const hideStepperProgress = ['petition_show', 'petition_update', 'promotion_completion_email'].includes(
		sourceLocation || '',
	);
	const pageTitle = hideStepperProgress ? translate('fe.components.psf.signature_goal_label') : progressBarLabelText;

	return {
		data: {
			pageTitle,
			hideStepperProgress,
		},
	};
}
